var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateWithWorksIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 106,
    viewBox: "0 0 176 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illus-bienancientravaux"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M3.0001 103H173",
    stroke: "#120136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M70.8555 101.822V94.2861H74.6797H78.5039V101.822H70.8555Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M67.0134 79.0718H63.1892H59.365V71.4648H67.0314L67.0134 79.0718Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M65.1104 82.8848H68.9346H72.7588V90.4917H68.9346H65.1104V82.8848Z",
    fill: "#FC901E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M103.406 90.4731H99.582V82.8662H103.406H107.23V90.4731H103.406Z",
    fill: "#FC901E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M112.976 79.0718H109.152H105.327V71.4648H112.994V79.0718H112.976Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M93.8188 101.822V94.2861H97.661H101.485V101.822H93.8188Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M105.309 101.822V94.2861H109.151H112.976V101.822H105.309Z",
    fill: "#FC901E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M59.3649 94.2861H63.1891H67.0133V101.822H59.3469L59.3649 94.2861Z",
    fill: "#FC901E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M80.425 90.4733H76.6008V80.978C76.6008 79.9269 75.739 79.0718 74.6797 79.0718H70.8555V71.4648H101.503V79.0718H97.6609C96.6016 79.0718 95.7398 79.9269 95.7398 80.978V90.4733H91.9156C90.8563 90.4733 89.9945 91.3284 89.9945 92.3794V101.821H82.3281V92.3794C82.3281 91.3284 81.4843 90.4733 80.425 90.4733Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.642 101.821H114.818V61.9693C114.818 60.9182 115.956 60.0631 114.897 60.0631H59.4439C58.3846 60.0631 57.5228 60.9182 57.5228 61.9693V101.821H45.0386L45.0386 27.1949L86.1704 9.3623L127.302 27.2127V101.821H120.642Z",
    fill: "#FFDE86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.731 33.5347L87.0502 9.9726C86.7809 9.83008 86.4757 9.75882 86.1705 9.75882C85.8653 9.75882 85.56 9.83008 85.2907 9.9726L39.5923 33.5347V28.0012L86.1705 1.75586L132.731 28.0012V33.5347Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6456 86.3203C35.7915 88.7317 38.085 91.9469 39.32 94.8941C40.6432 91.9469 42.9367 88.6424 46.9944 86.3203C45.2302 88.6424 44.1717 91.5003 43.466 94.0903C44.7891 91.411 47.0826 88.4638 50.7875 86.3203C48.4058 89.4462 47.2591 93.5545 46.7298 96.7696C49.9054 93.5545 52.64 94.6262 52.64 94.6262C50.1701 97.4841 49.9054 101.86 49.9054 101.86H28.7346C28.7346 101.86 28.3817 97.3948 26 94.6262C26 94.6262 28.7346 93.5545 31.9102 96.7696C31.2927 93.5545 30.146 89.4462 27.8525 86.3203C31.5574 88.4638 33.8509 91.3217 35.174 94.0903C34.4683 91.5003 33.4098 88.6424 31.6456 86.3203Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.106 86.3203C131.251 88.7317 133.545 91.9469 134.78 94.8941C136.103 91.9469 138.397 88.6424 142.454 86.3203C140.69 88.6424 139.632 91.5003 138.926 94.0903C140.249 91.411 142.543 88.4638 146.248 86.3203C143.866 89.4462 142.719 93.5545 142.19 96.7696C145.365 93.5545 148.1 94.6262 148.1 94.6262C145.63 97.4841 145.365 101.86 145.365 101.86H124.195C124.195 101.86 123.842 97.3948 121.46 94.6262C121.46 94.6262 124.195 93.5545 127.37 96.7696C126.753 93.5545 125.606 89.4462 123.312 86.3203C127.017 88.4638 129.311 91.3217 130.634 94.0903C129.928 91.5003 128.87 88.6424 127.106 86.3203Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M58.5061 102V59.9453H114.506V103",
    stroke: "#120136",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M63.1982 59.3802L62.555 51.7899L57.0744 50.0122L57.8125 43.3192L54.926 41.2783",
    stroke: "#120136",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path 7"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 58L78 51.1491C78 51.1491 86.4178 48.8509 93.1038 51.1491C93.1038 53.51 93.1038 58 93.1038 58",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 58L78 51.1491C78 51.1491 86.4178 48.8509 93.1038 51.1491C93.1038 53.51 93.1038 58 93.1038 58",
    stroke: "#120136",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fenetre"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.928 67.9017H74.276C73.466 67.9017 72.656 67.2537 72.656 66.2817V66.1197V65.9577V57.0477C72.656 56.0757 73.304 55.4277 74.276 55.4277H97.928C98.252 55.4277 98.576 55.5897 98.9 55.7517C99.548 55.9137 100.034 56.5617 100.034 57.2097V65.9577C100.034 66.7677 99.386 67.4157 98.738 67.5777C98.576 67.7397 98.252 67.9017 97.928 67.9017ZM92.258 64.6617H96.956V58.6677H92.258V64.6617ZM88.856 64.6617H83.996V58.6677H88.856V64.6617ZM75.896 64.6617H80.756V58.6677H75.896V64.6617Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.756 64.662H75.896V58.668H80.756V64.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8561 64.662H83.9961V58.668H88.8561V64.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9561 64.662H92.2581V58.668H96.9561V64.662Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "marteau"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M91.9819 30.6661L94.5256 26.036L101.627 30.2354C106.29 32.9273 112.013 33.8964 117.948 37.4497L145.928 53.8166L141.265 62C133.316 57.3699 120.598 49.9402 113.391 45.7408C107.456 42.2952 103.746 37.5574 99.0829 34.8655L91.9819 30.6661Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M85.6801 14.0477L94.4109 18.9224C93.6274 20.9805 93.5154 22.7137 93.8513 24.122C94.299 25.5302 95.1945 26.5051 95.978 27.0468L93.0677 31.9214C90.3813 31.3798 87.8068 32.3547 85.9039 33.8712C83.8891 35.4961 82.2101 37.8793 80.755 40.3708C78.8521 43.6205 77.6208 46.9786 76.7253 50.0117C76.0537 48.6035 75.2702 46.8703 74.8225 44.8121C73.3673 39.6125 73.8151 33.9796 76.3895 29.5382L85.6801 14.0477Z",
    fill: "#1E1548"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 10",
    d: "M58.5061 43.0002L64.3069 36.4473H67.0315",
    stroke: "#120136",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateWithWorksIcon);
export default __webpack_public_path__ + "static/media/estate-with-works-icon.1ac96daf.svg";
export { ForwardRef as ReactComponent };